// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:host {
  content-background-color: white;
}
:host ion-content {
  --background: #fff !important;
}
:host ion-list {
  background: var(--cms-app-background-color) !important;
}
:host ion-title {
  text-align: start;
  padding-inline: 3em;
}
:host ion-item.chat-row ion-row {
  width: 100%;
}
:host ion-textarea {
  overflow-y: scroll;
}
:host textarea.text-input {
  overflow: auto !important;
}
:host ion-footer.chat-footer ion-button {
  --color: #808080;
  margin: 0 auto;
  width: 100%;
}
:host ion-item-option {
  background: white;
  color: #808080;
  font-size: 1.2em;
}
:host .option {
  white-space: normal;
  margin-right: 4px;
  /*background: #63636340 !important;*/
  background: transparent;
  border: 1px solid #1884d4 !important;
  color: #1884d4 !important;
  font-size: 1rem;
  margin-top: 5px;
  padding: 8px;
  cursor: pointer;
}
:host .option-title {
  color: #1884d4 !important;
}
:host .option-container {
  margin-bottom: 15px;
  margin-left: 45px;
}
:host .options-container {
  width: 100%;
}
:host .contact-container {
  width: calc(100% - 47px);
  margin-bottom: 15px;
  margin-left: 45px;
}
:host .page-container {
  margin-bottom: 15px;
  margin-left: 45px;
}
:host .page-container ion-button {
  width: 100%;
  white-space: normal;
}
:host .contact-container img {
  max-height: 10em;
  object-fit: cover;
}
:host .contact-container .card-title {
  padding: 0em 1em;
  margin-bottom: 1em;
  font-weight: bold;
  font-size: 1rem;
}
:host .contact-container .card-subtitle {
  padding: 0em 1em;
}
:host .contact-container .card-subtitle:last-child {
  padding: 0em 1em;
  margin-bottom: 1em;
}
:host .contact-container .role {
  font-size: 1rem;
  margin-top: 8px;
}`, "",{"version":3,"sources":["webpack://./src/app/pages/chat-pages/full-screen-chat/full-screen-chat.page.scss"],"names":[],"mappings":"AAAA;EAmBI,+BAAA;AAjBJ;AADE;EACE,6BAAA;AAGJ;AAAE;EACE,sDAAA;AAEJ;AACE;EACE,iBAAA;EACA,mBAAA;AACJ;AAEI;EACE,WAAA;AAAN;AAME;EACE,kBAAA;AAJJ;AAME;EACE,yBAAA;AAJJ;AAOI;EACE,gBAAA;EACA,cAAA;EACA,WAAA;AALN;AAQE;EACE,iBAAA;EACA,cAAA;EACA,gBAAA;AANJ;AAQE;EACE,mBAAA;EACA,iBAAA;EACA,oCAAA;EACA,uBAAA;EACA,oCAAA;EACA,yBAAA;EACA,eAAA;EACA,eAAA;EACA,YAAA;EACA,eAAA;AANJ;AASE;EACE,yBAAA;AAPJ;AAUE;EACE,mBAAA;EACA,iBAAA;AARJ;AAWE;EACE,WAAA;AATJ;AAYE;EACE,wBAAA;EACA,mBAAA;EACA,iBAAA;AAVJ;AAaE;EACE,mBAAA;EACA,iBAAA;AAXJ;AAYI;EACE,WAAA;EACA,mBAAA;AAVN;AAcE;EACE,gBAAA;EACA,iBAAA;AAZJ;AAeE;EACE,gBAAA;EACA,kBAAA;EACA,iBAAA;EACA,eAAA;AAbJ;AAgBE;EACE,gBAAA;AAdJ;AAgBE;EACE,gBAAA;EACA,kBAAA;AAdJ;AAiBE;EACE,eAAA;EACA,eAAA;AAfJ","sourcesContent":[":host {\n  ion-content {\n    --background: #fff !important;\n  }\n\n  ion-list {\n    background: var(--cms-app-background-color) !important;\n  }\n\n  ion-title {\n    text-align: start;\n    padding-inline: 3em;\n  }\n  ion-item.chat-row {\n    ion-row {\n      width: 100%;\n    }\n  }\n  content: {\n    background-color: white;\n  }\n  ion-textarea {\n    overflow-y: scroll;\n  }\n  textarea.text-input {\n    overflow: auto !important;\n  }\n  ion-footer.chat-footer {\n    ion-button {\n      --color: #808080;\n      margin: 0 auto;\n      width: 100%;\n    }\n  }\n  ion-item-option {\n    background: white;\n    color: #808080;\n    font-size: 1.2em;\n  }\n  .option {\n    white-space: normal;\n    margin-right: 4px;\n    /*background: #63636340 !important;*/\n    background: transparent;\n    border: 1px solid #1884d4 !important;\n    color: #1884d4 !important;\n    font-size: 1rem;\n    margin-top: 5px;\n    padding: 8px;\n    cursor: pointer;\n  }\n\n  .option-title {\n    color: #1884d4 !important;\n  }\n\n  .option-container {\n    margin-bottom: 15px;\n    margin-left: 45px;\n  }\n\n  .options-container {\n    width: 100%;\n  }\n\n  .contact-container {\n    width: calc(100% - 47px);\n    margin-bottom: 15px;\n    margin-left: 45px;\n  }\n\n  .page-container {\n    margin-bottom: 15px;\n    margin-left: 45px;\n    ion-button {\n      width: 100%;\n      white-space: normal;\n    }\n  }\n\n  .contact-container img {\n    max-height: 10em;\n    object-fit: cover;\n  }\n\n  .contact-container .card-title {\n    padding: 0em 1em;\n    margin-bottom: 1em;\n    font-weight: bold;\n    font-size: 1rem;\n  }\n\n  .contact-container .card-subtitle {\n    padding: 0em 1em;\n  }\n  .contact-container .card-subtitle:last-child {\n    padding: 0em 1em;\n    margin-bottom: 1em;\n  }\n\n  .contact-container .role {\n    font-size: 1rem;\n    margin-top: 8px;\n  }\n\n  \n  \n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
